var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "builder form-preview-stage" }, [
    _c(
      "form",
      {
        staticClass: "contactum-form-builde",
        attrs: { method: "post", action: "", id: "contactum-form-builder" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.save_form_builder($event)
          }
        }
      },
      [
        _c("div", { staticClass: "builder-header" }, [
          _vm.post && _vm.post.post_title
            ? _c(
                "span",
                {
                  staticClass: "form-title",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.post_title_editing = true
                    }
                  }
                },
                [
                  _c("i", { staticClass: "el-icon-edit" }),
                  _vm._v(" " + _vm._s(_vm.post.post_title) + "\n          "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.post.post_title,
                        expression: "post.post_title"
                      }
                    ],
                    attrs: { type: "hidden", name: "post_title" },
                    domProps: { value: _vm.post.post_title },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.post, "post_title", $event.target.value)
                      }
                    }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "contactum-nav" }, [
            _c("ul", { staticClass: "contactum-tabs" }, [
              _c("li", [
                _c(
                  "a",
                  {
                    class: [_vm.isActiveTab("editor") ? "nav-tab-active" : ""],
                    attrs: { href: "#form-builder-container" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.makeActive("editor")
                      }
                    }
                  },
                  [_vm._v("Editor")]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "a",
                  {
                    class: [
                      _vm.isActiveTab("settings") ? "nav-tab-active" : ""
                    ],
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.makeActive("settings")
                      }
                    }
                  },
                  [_vm._v("Settings")]
                )
              ]),
              _vm._v(" "),
              _vm.hasNotification()
                ? _c("li", [
                    _c(
                      "a",
                      {
                        class: [
                          _vm.isActiveTab("notifications")
                            ? "nav-tab-active"
                            : ""
                        ],
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.makeActive("notifications")
                          }
                        }
                      },
                      [_vm._v("Notifications")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("li", [
                _c(
                  "a",
                  {
                    class: [
                      _vm.isActiveTab("integrations") ? "nav-tab-active" : ""
                    ],
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.makeActive("integrations")
                      }
                    }
                  },
                  [_vm._v("Integration")]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "builder-save" }, [
            _vm.post && _vm.post.ID
              ? _c(
                  "span",
                  {
                    staticClass: "form-id btn btn-copy",
                    attrs: {
                      title: "click to copy shortcode",
                      "data-clipboard-text": _vm.shortcode
                    }
                  },
                  [
                    _c("i", { staticClass: "el-icon-document-copy" }),
                    _vm._v(
                      '\n              [contactum id="' +
                        _vm._s(_vm.post.ID) +
                        '"]\n          '
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "save_form_builder" },
              [
                _c("EmbedModal", {
                  attrs: {
                    visible: _vm.showembeddialog,
                    shortcode: _vm.shortcode
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.showembeddialog = $event
                    },
                    close: function($event) {
                      _vm.showembeddialog = false
                    },
                    "embed-form": _vm.save_form_builder
                  }
                }),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.showembeddialog = true
                      }
                    }
                  },
                  [_vm._v(" Embed ")]
                ),
                _vm._v(" "),
                _c("button", { attrs: { type: "submit" } }, [
                  _vm._v(" Save Form "),
                  _vm.loading == true
                    ? _c("span", { staticClass: "showLoading" }, [
                        _c("i", {
                          staticClass: "fa fa-spinner fa-pulse",
                          attrs: { "aria-hidden": "true" }
                        })
                      ])
                    : _vm._e()
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isActiveTab("editor"),
                expression: "isActiveTab('editor')"
              }
            ],
            staticClass: "form-builder-container"
          },
          [
            _c("header", [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.post_title_editing,
                      expression: "post_title_editing"
                    }
                  ]
                },
                [
                  _c("RenameForm", {
                    attrs: {
                      post: _vm.post,
                      post_title_editing: _vm.post_title_editing,
                      visible: _vm.post_title_editing
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.post_title_editing = $event
                      },
                      "rename-form": _vm.save_form_builder,
                      close: function($event) {
                        _vm.post_title_editing = false
                      }
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "builder-body" }, [
              _c("section", { staticClass: "form-field" }, [
                _vm.settings
                  ? _c(
                      "ul",
                      {
                        class: [
                          "contactum-form",
                          "sortable-list",
                          "form-label-" + _vm.settings.label_position
                        ]
                      },
                      [
                        !_vm.form_fields.length
                          ? _c("li", { staticClass: "empty-state" }, [
                              _c("h3", [_vm._v("Start building your form")]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "Drag fields from the right panel to begin."
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.form_fields, function(field, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              class: [
                                field.name,
                                field.css,
                                "form-field-" + field.template,
                                "field-items",
                                field.width ? "field-size-" + field.width : ""
                              ],
                              attrs: {
                                "data-index": index,
                                "data-source": "stage"
                              }
                            },
                            [
                              _c("div", { staticClass: "contactum-label" }, [
                                !_vm.is_full_width(field.template) &&
                                field.template != "submit_field" &&
                                  field.template != "name_field"
                                  ? _c("label", [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(field.label) +
                                          "\n                      "
                                      ),
                                      field.required && "yes" === field.required
                                        ? _c(
                                            "span",
                                            { staticClass: "required" },
                                            [_vm._v("*")]
                                          )
                                        : _vm._e()
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("form_" + field.template, {
                                tag: "component",
                                attrs: { field: field }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "control-button" }, [
                                _c("i", { staticClass: "fa fa-arrows move" }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.select_field(field)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "el-icon-edit" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.delete_field(index)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "el-icon-delete" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.duplicate_field(field, index)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-copy-document"
                                    })
                                  ]
                                )
                              ])
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "hidden", name: "contactum_form_id" },
                  domProps: { value: _vm.post.ID }
                }),
                _vm._v(" "),
                _vm.hasSubmitField() == undefined
                  ? _c("div", { staticClass: "submit_wrapper" }, [
                      _c("input", {
                        staticClass: "btn-submit",
                        attrs: { type: "submit", disabled: "" },
                        domProps: { value: _vm.settings.submit_text }
                      })
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field-panel" }, [
                _c("div", { staticClass: "forms-fields-tab" }, [
                  _c(
                    "button",
                    {
                      class: [
                        "fields",
                        "form_fields" === _vm.current_panel ? "active" : ""
                      ],
                      attrs: { id: "add-fields" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.sidebartab("form_fields")
                        }
                      }
                    },
                    [_vm._v("Add Fields")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      class: [
                        "field_options" === _vm.current_panel ? "active" : "",
                        !_vm.form_fields.length ? "disabled" : ""
                      ],
                      attrs: {
                        id: "field-options",
                        disabled: !_vm.form_fields.length
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.sidebartab("field_options")
                        }
                      }
                    },
                    [_vm._v("Field Options")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "forms-sidbar-tab-content" },
                  [_c(_vm.current_panel, { tag: "component" })],
                  1
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isActiveTab("settings"),
                expression: "isActiveTab('settings')"
              }
            ],
            staticClass: "form-builder-settings"
          },
          [_c("form_settings", { attrs: { id: _vm.id } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isActiveTab("notifications"),
                expression: "isActiveTab('notifications')"
              }
            ],
            staticClass: "form-builder-notifications"
          },
          [
            _c("form_notifications", {
              on: { "save-notification": _vm.save_form_builder }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.isActiveTab("integrations")
          ? _c(
              "div",
              { staticClass: "form-builder-notifications" },
              [
                _c("Intergrations", {
                  on: { "save-integration": _vm.save_form_builder }
                })
              ],
              1
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }